import React from 'react';
import { useIdPrefix } from '../../IdPrefix';
import { styles } from './ProductServiceButton.css';
import { formatMoney } from '@jbhi-fi/lanyard-ui/global/utils';

export type ProductServiceButtonProps = {
  onButtonClick: (event: React.SyntheticEvent, offeringId: string) => void;
  selected: boolean;
  isCompare?: boolean;
  shouldHighlightSelection?: boolean;
  shouldHaveMinHeight?: boolean;
  offeringId: string;
  elementId?: string;
  heading?: string;
  price?: number;
  icon?: React.ReactNode;
};

export const ProductServiceButton = ({
  onButtonClick,
  selected,
  isCompare = false,
  shouldHighlightSelection,
  shouldHaveMinHeight = false,
  offeringId,
  elementId,
  heading,
  price,
  icon,
}: ProductServiceButtonProps) => {
  const idPrefix = useIdPrefix(elementId);
  const testId = useIdPrefix(`product-service-button${elementId ? `-${elementId}` : ''}`);

  return (
    <>
      <button
        id={idPrefix}
        data-testid={testId}
        className={styles.productServiceButton({
          ...(shouldHighlightSelection
            ? { selectedHighlighted: selected, isCompareHighlighted: isCompare }
            : { selected, isCompare }),
        })}
        onClick={event => onButtonClick(event, offeringId)}
      >
        {!isCompare && icon ? <>{icon}</> : null}
        <div className={styles.productServiceText({ isCompare })}>
          <span className={styles.typeOfCover({ selected: selected && !isCompare, isCompare })}>{heading}</span>
          <span
            className={styles.price({
              isCompare,
              ...(shouldHighlightSelection ? { selectedHighlighted: selected } : {}),
            })}
          >
            {price ? formatMoney(price) : shouldHaveMinHeight ? <div>&nbsp;</div> : null}
          </span>
        </div>
        {selected && !shouldHighlightSelection ? (
          <div className={styles.selectedTextWrapper}>
            <span className={styles.selectedText({ isCompare })}>Selected</span>
          </div>
        ) : null}
      </button>
    </>
  );
};
